import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterAltCb = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.2212 3.5H11.7212L7.9637 8.225L4.2212 3.5ZM2.1587 3.2075C3.6737 5.15 6.4712 8.75 6.4712 8.75V13.25C6.4712 13.6625 6.8087 14 7.2212 14H8.7212C9.1337 14 9.4712 13.6625 9.4712 13.25V8.75C9.4712 8.75 12.2612 5.15 13.7762 3.2075C14.1587 2.7125 13.8062 2 13.1837 2H2.7512C2.1287 2 1.7762 2.7125 2.1587 3.2075Z",
		fill: "currentColor"
	})
});
export default SvgFilterAltCb;
